<template>
  <input
    :type="type"
    class="w-full h-12 px-4 font-semibold text-gray-900 rounded focus:outline-none focus:ring-4 ring-blue-500"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: ["type", "value"],
};
</script>
